export default "__VITE_ASSET__DiA0e5bG__"